import { render, staticRenderFns } from "./CompanyMobileMultiEmployeeMealSummary.vue?vue&type=template&id=bdf0af86"
import script from "./CompanyMobileMultiEmployeeMealSummary.vue?vue&type=script&lang=js"
export * from "./CompanyMobileMultiEmployeeMealSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports